import React from "react";
import { FilterField } from "../types";

interface ModalInputProps {
  field: FilterField;
  onFieldChange: (name: string, value: string) => void;
}

const ModalInput: React.FC<ModalInputProps> = ({ field, onFieldChange }) => {
  const applyMask = (value: string, mask: string) => {
    let maskedValue = "";
    let valueIndex = 0;

    for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
      if (mask[i] === "9") {
        if (/\d/.test(value[valueIndex])) {
          maskedValue += value[valueIndex];
          valueIndex++;
        } else {
          break;
        }
      } else {
        maskedValue += mask[i];
      }
    }

    return maskedValue;
  };

  const handleInputChange = (value: string) => {
    if (field.mask) {
      const rawValue = value.replace(/\D/g, "");
      const maskedValue = applyMask(rawValue, field.mask);
      onFieldChange(field.name, maskedValue);
    } else {
      onFieldChange(field.name, value);
    }
  };

  return (
    <input
      type={field.type === "date" ? "date" : "text"}
      placeholder={field.placeholder}
      value={field.value}
      onChange={(e) => handleInputChange(e.target.value)}
      className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary"
    />
  );
};

export default ModalInput;
